
import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserDataService } from 'app/services/user-data.service';
import { Enterprise, Department, ParticipantData, companyStaff, client, stuffSalary } from 'app/models/enterprise-model';
import { EntServiceService } from 'app/services/ent-service.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { InitialiseService } from 'app/services/initialise.service';

import * as moment from 'moment';
import { map, find } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { Task } from 'app/models/task-model';
import { Project, workItem } from 'app/models/project-model';
import { WriteService } from 'app/services/writes.service';
import { ChatService } from 'app/services/chat.service';
import { RouteService } from 'app/services/route.service';
import { IconsService } from 'app/services/icons.service';
import { TaskService } from 'app/services/task.service';
import { AdminService } from 'app/services/admin.service';
import { NotificationService } from 'app/services/notification.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

declare var require: any
declare var $: any;

@Component({
  selector: 'app-ent-staff',
  templateUrl: './ent-staff.component.html',
  styleUrls: ['./ent-staff.component.css']
})

export class EntStaffComponent implements OnInit {
  exitStaff: any;
  showShaff = false;
  setClient: client;
  public addMember = false;
  public showDpts = true;
  public showDptOne = false;
  public addDpart = false;
  public editProfile = true;
  public editJoinDate = false;
  supervisor;
  public newStaff = true;
  public newStaff1 = true;
  value = '';
  results: any;
  department: Department;
  newMember: any;
  dpt: Department;
  public newCusInfo = false;
  cusInfo: client;
  n = 1;
  changList = [];
  searchingValue = '';
  setDone: boolean;
  oldMans = [];
  elseaddDpt = false;
  modalRef2: any;

  constructor(private activatedroute: ActivatedRoute, public usd: UserDataService, public es: EntServiceService, public ico: IconsService,
    public tsk: TaskService, private afs: AngularFirestore, public is: InitialiseService, public ws: WriteService, public cs: ChatService,
    public rs: RouteService, public ad: AdminService, public ns: NotificationService, public modalService: NgbModal) {
    this.dpt = is.getDeptInit();
    this.department = is.getDeptInit();
    if (!es?.staff) {
      this.rs.gotoEntList();
    }
  }

  openLgg(template: TemplateRef<any>) {
    this.modalRef2 = this.modalService.open(template, { size: 'lg' })
  }
  
  searchresult() {
    this.afs.collection<any>('Users').valueChanges().subscribe(users => {
      this.layWord(users, this.value);
    })
  }

  layWord(allUsers, value) {
    let word = value; const results = [];
    allUsers.forEach(man => {
      if (man.name) {
        // man.name = man.name.toLowerCase();
        const name = man?.name?.toLowerCase();
        if (word !== '' || ' ') {
          word = word.toLowerCase();
          if (name?.includes(word)) {
            // man.name = man.name.charAt(0).toUpperCase() + man.name.slice(1);
            results.push(man);
            // console.log(results);
            this.results = results;
            const exist = this.es?.staff.find((item) => item.id === man.id);
            if (exist) {
              man.join = true;
              // console.log('true');
            } else {
              // console.log('false');
              man.join = false;
            }
          }
        }
      }
      return this.results;
    });
  }

  async saveDept(dpt) {
    // console.log(dpt);
    this.showDpts = true;
    // console.log(this.usd.setCompany);
    dpt.companyName = this.usd.setCompany.name;
    dpt.companyId = this.usd.setCompany.id;
    // const data = await this.ws.addDept(dpt);
    // this.department = await this.ws.addDept(dpt);
    // const data = this.ws.addDpart(dpt).then(dta => console.log(dta))
    // this.department = await this.ws.addDpart(dpt);
    this.newMember.department = this.department.name; this.newMember.departmentId = this.department.id
    // console.log(this.department);
  }

  ngOnInit(): void {
    const tagClass = $('.tagsinput').data('color');

    if ($('.tagsinput').length !== 0) {
      $('.tagsinput').tagsinput();
    }

    $('.bootstrap-tagsinput').addClass('' + tagClass + '-badge');

    //  Init Bootstrap Select Picker
    if ($('.selectpicker').length !== 0) {
      $('.selectpicker').selectpicker({
        iconBase: 'nc-icon',
        tickIcon: 'nc-check-2'
      });
    }
  }

}
